export interface IPurchaseModal {
  _id: string
  name: string
  description: string
  dedication: string
  program: string
  dates: Date[]
}

export interface Date {
  _id: string
  startDate: string
  endDate: string
  startHour: string
  endHour: string
  days: string[]
  linkPurchase: string
}

export class PurchaseModal {
  _id: string
  name: string
  description: string
  dedication: string
  program: string
  dates: Date[]
  constructor(from: IPurchaseModal) {
    this._id = from._id
    this.name = from.name
    this.description = from.description
    this.dedication = from.dedication
    this.program = from.program
    this.dates = from.dates
  }
}
